<template>
  <div class="reset-password">
    <modal>
      <div slot="body" class="body">
        <cactus-password-forgotten :userParam="userNameParam" :codeParam="resetCodeParam" />
      </div>
    </modal>
  </div>
</template>

<script>
import _ from 'lodash';
import { CactusEventBus } from '@cactus-web/authenticator';
import Modal from '../_common/modal';

export default {
  name: 'ResetPassword',
  components: {
    Modal
  },
  data() {
    return {
      resetCodeParam: '',
      userNameParam: ''
    };
  },
  created() {
    if (_.has(this.$route.query, 'email')) {
      this.resetCodeParam = this.$route.query.code;
      this.userNameParam = this.$route.query.email;
    }

    CactusEventBus.$on('authState', info => {
      this.$log.info('App.js::cactusAuthenticate():', info);
      switch (info) {
        case 'redirectWithParams':
          // redirect to / if new password has been confirmed
          this.redirect();
          break;
      }
    });
  },
  methods: {
    redirect() {
      this.$router.replace('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.reset-password {
  .body {
    max-width: $maxWidth;
    margin: 0 auto;
  }
}
</style>
